import { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import NotFound from "../pages/NotFound";

const PageLoader = () => (
  <div
    role="status"
    aria-live="polite"
    style={{
      minHeight: "40vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    Loading…
  </div>
);

const Router = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Styles />
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content">
        <Switch>
          {routes.map((routeItem) => (
            <Route
              key={`${routeItem.component}-${routeItem.path.join()}`}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          ))}
          <Redirect from="/terms-&-conditions" to="/terms-and-conditions" />
          <Route component={NotFound} />
        </Switch>
      </main>
      <Footer />
    </Suspense>
  );
};

export default Router;
